import { Component } from '@angular/core';
import { LabelledBlockInputWrapperComponent } from '@components/labelled-block-input-wrapper/labelled-block-input-wrapper.component';

@Component({
    selector: 'app-input-search-wrapper',
    templateUrl: './input-search-wrapper.component.html',
    styleUrls: [
        './input-search-wrapper.component.css',
        '../labelled-block-input-wrapper/labelled-block-input-wrapper.component.css',
    ],
    standalone: false
})
export class InputSearchWrapperComponent extends LabelledBlockInputWrapperComponent {}
